import { render, staticRenderFns } from "./ContentWork.vue?vue&type=template&id=4a58df0a&scoped=true&"
import script from "./ContentWork.vue?vue&type=script&lang=js&"
export * from "./ContentWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58df0a",
  null
  
)

export default component.exports